import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { Label } from "reactstrap";
import useFieldItem from "../../widgets/fields/UseFieldItem";
import { QuestionFormElements } from "./FormElements";
import { FIELD_TYPES, FieldItem } from "../../widgets/fields";
import { ArrowLeftOutlined, CaretLeftOutlined, CaretRightOutlined, FundViewOutlined, PieChartOutlined } from "@ant-design/icons";
import { postUserActivityLms, postUserTestActivityLms } from "./apiController";
import { CustomButton, showToaster, toasterTypes } from "../../widgets";
import ModalComponent from "../common/Modal/modal";
import { TrophyOutlined, CheckCircleOutlined, ExclamationCircleOutlined, BookOutlined } from '@ant-design/icons';

export default function ModuleVideo() {
    const location = useLocation();
    const navigate = useNavigate();
    const [data, setData] = useState<any>([]);
    const [isPretestCompleted, setIsPretestCompleted] = useState(false);
    const [pretestValues, pretestFields, handlePretestChange, { validateValues: validatePretestValues }] = 
        useFieldItem(QuestionFormElements, {}, { onValueChange: onPretestValueChange });
    const [posttestValues, posttestFields, handlePosttestChange, { validateValues: validatePosttestValues }] = 
        useFieldItem(QuestionFormElements, {}, { onValueChange: onPosttestValueChange });
    const [complete, setComplete] = useState(false);
    const [hasQuestions, setHasQuestions] = useState(true);
    const [modData, setModData] = useState<any>(location.state);
    const [videoIndex, setVideoIndex] = useState(1);
    const [pretestActivity, setPretestActivity] = useState<any>([]);
    const [posttestActivity, setPosttestActivity] = useState<any>([]);
    const [questionData, setQuestion] = useState<any>([]);
    const [userActivityData, setUserActivityData] = useState<any>([]);
    const [postTestScoreModal, setPostTestScoreModal] = useState(false);
    const [postTestResult, setPostTestResult] = useState<any>([]);

    useEffect(() => {
        let questionData: any = location.state;
        setUserActivityData(questionData.data);
        setQuestion(questionData.data && questionData.data.questions);

        const questionsExist = questionData.data?.questions && questionData.data.questions.length > 0;
        setHasQuestions(questionsExist);
        
        if (!questionsExist) {
            setIsPretestCompleted(true);
        } else {
            const initialTestActivity = questionData.data.questions.map(item => ({
                questionId: item.questionId,
                question: item.question,
                options_selected: []
            }));

            setPretestActivity([...initialTestActivity]);
            setPosttestActivity([...initialTestActivity]);

            // Format options for each question
            const formattedQuestions = questionData.data.questions.map(item => ({
                ...item,
                options: item.options?.map(opt => ({ 
                    label: opt.option, 
                    value: opt.value 
                }))
            }));

            questionData.data.questions = formattedQuestions;
            
            const userActiviy = questionData?.data?.user_activity;
            const hasAttempted = userActiviy?.some(item => item.isAttempted);
            setIsPretestCompleted(hasAttempted);
        }
        
        setData(questionData.data);
    }, []);

    function handleTestValueChange(name, value, values, isPretest = true) {
        const questionIndex = name - 1;
        const question = questionData[questionIndex];
        const updateActivity = (prev) => {
            const newActivity = [...prev];
            
            if (question.question_type.toLowerCase() === "radio button") {
                // For radio buttons, store the complete selected option
                const [optionValue,optionText] = value.split("_");
                const selectedOption = question.options.find(opt => String(opt.value) === String(optionValue) && String(opt.option) === String(optionText));
                if (selectedOption) {
                    newActivity[questionIndex] = {
                        ...newActivity[questionIndex],
                        options_selected: [selectedOption]
                    };
                }
            } 
            else if (question.question_type.toLowerCase() === "check box") {
                const selectedValues = Array.isArray(value) ? value : [value];
                const selectedOptions = selectedValues.map(val => {
                    const [optionValue, optionText] = val.split("_");
                    return question.options.find(opt => 
                        String(opt.value) === String(optionValue) && 
                        String(opt.option) === String(optionText)
                    );
                }).filter(Boolean);
                newActivity[questionIndex] = {
                    ...newActivity[questionIndex],
                    options_selected: selectedOptions
                };
            }
            else if (question.question_type.toLowerCase() === "text") {
                newActivity[questionIndex] = {
                    ...newActivity[questionIndex],
                    options_selected: [{ option: value, value: 0 }]
                };
            }
            
            return newActivity;
        };

        if (isPretest) {
            setPretestActivity(prev => updateActivity(prev));
        } else {
            setPosttestActivity(prev => updateActivity(prev));
        }

        // Return updated values for the form
        return [{ ...values, [name]: value }];
    }

    function onPretestValueChange(name, value, values) {
        return handleTestValueChange(name, value, values, true);
    }

    function onPosttestValueChange(name, value, values) {
        return handleTestValueChange(name, value, values, false);
    }

    const validateAnswers = (testActivity) => {
        // Check if any question has empty options_selected
        const hasUnansweredQuestions = testActivity.some(
            answer => !answer.options_selected || answer.options_selected.length === 0
        );
        return hasUnansweredQuestions;
    };


    const submitPretest = async () => {
        if (validateAnswers(pretestActivity)) {
            showToaster(toasterTypes.ERROR, "Please answer all questions");
            return;
        }
        const questionIds = data?.questions?.map(q => q.questionId.toString()) || [];

        if (validatePretestValues(questionIds)) {
            showToaster(toasterTypes.ERROR, "Please answer all questions highlighted in red");
            return;
        }

        try {
            const pretestObj = {
                module_m_id: data.id,
                course_id: modData.moduData,
                usernumber: modData.uid,
                contentId: videoIndex - 1,
                content_type: "video",
                module_id: data.moduleId,
                pretest_user_answers: pretestActivity
            };
            const response = await postUserTestActivityLms(pretestObj,"p");
            if (response.success) {
                showToaster(toasterTypes.SUCCESS, "Pretest submitted successfully");
                setIsPretestCompleted(true);
            } else {
                showToaster(toasterTypes.ERROR, "Something went wrong. Please try again");
            }
        } catch (error) {
            showToaster(toasterTypes.ERROR, "Error submitting pretest");
        }
    };

    const submitPosttest = async () => {
        if (validateAnswers(posttestActivity)) {
            showToaster(toasterTypes.ERROR, "Please answer all questions");
            return;
        }
        const questionIds = data?.questions?.map(q => q.questionId.toString()) || [];
        
        // Validate all question fields
        if (validatePosttestValues(questionIds)) {
            showToaster(toasterTypes.ERROR, "Please answer all questions highlighted in red");
            return;
        }

        try {
            const posttestObj = {
                module_m_id: data.id,
                course_id: modData.moduData,
                usernumber: modData.uid,
                contentId: videoIndex - 1,
                content_type: "video",
                module_id: data.moduleId,
                posttest_user_answers: posttestActivity
            };

            const response = await postUserTestActivityLms(posttestObj,"pp");
            if (response.success) {
                showToaster(toasterTypes.SUCCESS, "Posttest submitted successfully");
                setPostTestScoreModal(true);
                setPostTestResult(response?.posttest_result);
                // setPostTestResult("Very Good");
            } else {
                showToaster(toasterTypes.ERROR, "Something went wrong. Please try again");
            }
        } catch (error) {
            showToaster(toasterTypes.ERROR, "Error submitting posttest");
        }
    };

    const updateActivity = async (isAttempt, isComplete, viewPercent) => {
        try {
            const activityObj = {
                module_m_id: data.id,
                isAttempted: isAttempt,
                isCompleted: isComplete,
                contentId: videoIndex - 1,
                content_type: "video",
                view_percent: Math.floor(viewPercent)
            };
            
            await postUserActivityLms(
                modData.uid, 
                data.moduleId, 
                modData.moduData, 
                activityObj
            );
        } catch (error) {
            console.error("Error updating activity:", error);
        }
    };

    const getPlay = (e) => {
        const duration = e.target.duration;
        const currentTime = e.target.currentTime;
        const isComplete = (duration * 90) / 100;
        const viewPercent = (currentTime / duration) * 100;

        if (currentTime > isComplete) {
            setComplete(true);
            updateActivity(true, true, viewPercent);
        } else {
            updateActivity(true, false, viewPercent);
            setComplete(false);
        }
    };

    const changeVideo = (index) => {
        if (index === "next") {
            setVideoIndex(prev => prev + 1);
        } else if (index === "prev") {
            setVideoIndex(prev => prev - 1);
        } else {
            setVideoIndex(index);
        }
    };

    const renderQuestions = (values, fields, handleChange, isPretest = true) => {
        return <>
            {data?.questions?.map((item, index) => (
                <React.Fragment key={item.questionId}>
                    <span className="question">
                        {item.questionId}. {item.question}
                    </span>
                    
                    <div className="options">
                        <FieldItem
                            name={item.questionId}
                            placeholder={item.question_type === "text" ? "Type your answer here" : ""}
                            value={values[item.questionId]}
                            values={item.options?.map(opt => ({
                                label: opt.label,
                                value: `${opt.value}_${opt.label}`
                            }))}
                            type={
                                item.question_type.toLowerCase() === "radio button" 
                                    ? FIELD_TYPES.RADIO_BUTTON 
                                    : item.question_type.toLowerCase() === "check box"
                                    ? FIELD_TYPES.CHECK_BOX
                                    : FIELD_TYPES.TEXT
                            }
                            isMandatory={true}
                            onChange={(...e) => handleChange(item.questionId, ...e)}
                            touched={fields[item.questionId]?.hasError}
                            error={fields[item.questionId]?.errorMsg}
                        />
                    </div>
                    <hr />
                </React.Fragment>
            ))}
            <div className="save-btn">
                <CustomButton
                    type="primary"
                    onClick={isPretest ? submitPretest : submitPosttest}
                    className="w-50 save"
                    text={isPretest ? "Submit Pretest" : "Submit Posttest"}
                />
            </div>
        </>
    };
        const resultConfigs = {
            "Excellent": {
            icon: <TrophyOutlined style={{ fontSize: 24, color: '#52c41a' }} />,
            title: "Outstanding Achievement!",
            message: "Exceptional work! You've demonstrated a thorough understanding of the material.",
            subMessage: "Keep up the fantastic work! You're mastering this course.",
            color: '#52c41a',
            status: 'success',
            percent: "90-100"
          },
          "Very Good": {
            icon: <CheckCircleOutlined style={{ fontSize: 24, color: 'var(--primary-color, #1890ff)' }} />,
            title: "Great Performance!",
            message: "Well done! You've shown strong comprehension of the course material.",
            subMessage: "Your hard work is paying off. Keep this momentum going!",
            color: 'var(--primary-color, #1890ff)',
            status: 'success',
            percent: "80-90"
          },
          "Good": {
            icon: <ExclamationCircleOutlined style={{ fontSize: 24, color: '#faad14' }} />,
            title: "Good Progress!",
            message: "You're on the right track with a solid foundation.",
            subMessage: "Review some concepts to strengthen your understanding further.",
            color: '#faad14',
            status: 'normal',
            percent: "60-80"
          },
          "Poor": {
            icon: <BookOutlined style={{ fontSize: 24, color: '#ff4d4f' }} />,
            title: "Room for Improvement",
            message: "Learning is a journey, and every attempt helps you grow.",
            subMessage: "Consider reviewing the material and trying again. You've got this!",
            color: '#ff4d4f',
            status: 'exception',
            percent: "<60"
          }
        };
      
    return (
        <>
        {
            postTestScoreModal && (
                <ModalComponent 
                width={window.innerWidth > 750 ? "40%" : "95%"}
                isOpen={true}
                onClose={() => {
                    navigate("/coursemodule", { 
                        state: { 
                            id: modData.moduData, 
                            uid: modData.uid 
                        } 
                    });
                    setPostTestScoreModal(false);
                }}
                customClass="post-test-modal"
                header={"Post Test Result"}
                centered={true}
                body={
                    postTestResult &&
                    (
                        <div className="modal-content">
                            <span>{resultConfigs[postTestResult].icon}</span>
                        
                        <h2 className="result-title">{resultConfigs[postTestResult].title}</h2>
                        <p className="result-message">{resultConfigs[postTestResult].message}</p>
                        <p className="result-submessage">{resultConfigs[postTestResult].subMessage}</p>
                        <p className="result-score">Your Score : {resultConfigs[postTestResult].percent}</p>
                    </div>
                    )
                }
                footer=""
            />
            )
        }
        <div className="video-container">
            <Row className="header">
                <Col md={6}>
                    <ArrowLeftOutlined 
                        style={{ color: "#fff", fontSize: "24px", margin: "0px 10px" }}
                        onClick={() => navigate("/coursemodule", { 
                            state: { 
                                id: modData.moduData, 
                                uid: modData.uid 
                            } 
                        })}
                    />
                    <span className="quest-head">Go Back</span>
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <div className="left-panel">
                        {(!hasQuestions || isPretestCompleted) ? (
                            <>
                                <div className="video">
                                    <video 
                                        src={data?.videos?.[videoIndex - 1]}
                                        width="100%"
                                        height="100%"
                                        controls
                                        onPause={getPlay}
                                        onEnded={getPlay}
                                    />
                                </div>
                                {userActivityData.user_activity?.[videoIndex-1]?.attempt_count > 0 && (
                                    <>
                                        <Row style={{marginBottom:"20px", padding: "0 20px"}}>
                                            <Col md={6}>
                                                <div style={{fontSize:"26px"}}>
                                                    <FundViewOutlined style={{color:"var(--primary-color, #006BD9)"}}/> 
                                                    {userActivityData.user_activity[videoIndex-1].attempt_count}
                                                    <span style={{fontSize:"16px", color:"rgb(127 123 123)"}}> attempts</span>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div style={{fontSize:"26px"}}>
                                                    <PieChartOutlined style={{color:"var(--primary-color, #006BD9)"}}/> 
                                                    {userActivityData.user_activity[videoIndex-1].view_percent}%
                                                </div>
                                            </Col>
                                        </Row>
                                        <hr />
                                    </>
                                )}
                                
                                {
                                data?.videos?.length > 1 &&
                                <Row>
                                    <Col md={1}>
                                        <button 
                                            className="progress-previous-btn"
                                            onClick={() => changeVideo("prev")}
                                            disabled={videoIndex === 1}
                                        >
                                            <CaretLeftOutlined />
                                        </button>
                                    </Col>
                                    <Col md={8}>
                                            <div className="video-slider">
                                            <ul className="progressbar-ul">
                                                {data?.videos?.map((_, index) => (
                                                    <li className="video-li" key={index}>
                                                        <div 
                                                            className={videoIndex === index + 1 ? "video-count-select" : "video-count"}
                                                            onClick={() => changeVideo(index + 1)}
                                                        >
                                                            {index + 1}
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </Col>
                                    <Col md={1}>
                                        <button 
                                            className="progress-next-btn"
                                            onClick={() => changeVideo("next")}
                                            disabled={data?.videos?.length === videoIndex}
                                        >
                                            <CaretRightOutlined />
                                        </button>
                                    </Col>
                                </Row>
                                }   
                                <div className="description">
                                    <h4>{data?.title}</h4>
                                    <h6><b>Description</b></h6>
                                    <p>{data?.description}</p>
                                </div>
                            </>
                        ) : (
                            <div className="pretest-container">
                                <h3>Pretest</h3>
                                <p>Please complete the pretest before watching the video.</p>
                                {renderQuestions(pretestValues, pretestFields, handlePretestChange)}
                            </div>
                        )}
                    </div>
                </Col>
                <Col md={6}>
                    {hasQuestions && isPretestCompleted && (
                        <>
                            <span className="quest-head-right">Posttest Questions</span>
                            {!complete && <p>Please complete watching the video before posttest.</p>}
                            {complete && (
                                <div className="right-panel">
                                    {renderQuestions(posttestValues, posttestFields, handlePosttestChange, false)}
                                </div>
                            )}
                        </>
                    )}
                </Col>
            </Row>
        </div>

        </>
    );
}